import React from 'react';
import moment from 'moment';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer';
import CustomInput from 'components/CustomInput/CustomInput.jsx';

export default function CashbackSection({ cashbackInsurance }) {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={3} lg={3}>
        <CustomInput
          labelText="Preis (CHF)"
          inputProps={{
            value: `${(cashbackInsurance.price / 100).toFixed(2)}`,
            disabled: true,
          }}
          formControlProps={{
            fullWidth: true,
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={3} lg={3}>
        <CustomInput
          labelText="Status"
          inputProps={{
            value: cashbackInsurance.used ? 'Benutzt' : 'Unbenutzt',
            disabled: true,
          }}
          formControlProps={{
            fullWidth: true,
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={3} lg={3}>
        <CustomInput
          labelText={'G\u00fcltig bis'}
          inputProps={{
            value: moment(cashbackInsurance.validTo)
              .subtract(1, 'day')
              .format('DD.MM.YYYY'),
            disabled: true,
          }}
          formControlProps={{
            fullWidth: true,
          }}
        />
      </GridItem>
    </GridContainer>
  );
}



// WEBPACK FOOTER //
// ./src/views/skidata/components/CashbackSection.jsx